import { useCallback, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Ribbon } from "@/components/site/Ribbon";
import { Manifesto } from "@/components/site/Manifesto";
import { Services } from "@/components/site/Services";
import { Doctors } from "@/components/site/Doctors";
import { Testimonials } from "@/components/site/Testimonials";
import { Financing } from "@/components/site/Financing";
import { Resources } from "@/components/site/Resources";
import { FAQ } from "@/components/site/FAQ";
import { Statement } from "@/components/site/Statement";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  const contactRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 300);
    }
  }, [location]);

  const scrollToContact = useCallback(() => {
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setTimeout(() => {
      const name = document.querySelector('[data-testid="form-name"]');
      if (name) name.focus();
    }, 900);
  }, []);

  return (
    <div className="relative">
      <Navbar onBook={scrollToContact} />
      <Hero onBook={scrollToContact} />
      <Ribbon />
      <Manifesto />
      <Services />
      <Doctors onBook={scrollToContact} />
      <Testimonials />
      <Financing />
      <Resources />
      <FAQ />
      <Statement onBook={scrollToContact} />
      <Contact ref={contactRef} />
      <Footer onBook={scrollToContact} />
    </div>
  );
}
